
function initProductGalleryVideos() {
  const firstVideo = document.querySelector('.product-main-slider .slide.slick-active video');
  if (!firstVideo) return;

  loadVideo(firstVideo);
}

function loadVideo(video) {
  if (!video) return;

  const hlsUrl = video.dataset.hls;
  const mp4Url = video.dataset.src;

  video.muted = true;
  video.setAttribute('muted', '');
  video.setAttribute('playsinline', '');
  video.setAttribute('webkit-playsinline', '');
  // Don't set autoplay here - let initAndPlay handle it after video is ready
  video.removeAttribute('autoplay');
  video.removeAttribute('loop');

  // Remove the old click handler that auto-plays
  // Video playback will be controlled by initAndPlay function

  if (hlsUrl && hlsUrl.endsWith('.m3u8')) {
    window.cwEnsureHls().then(function () {
    if (!(window.Hls && Hls.isSupported()) && video.canPlayType('application/vnd.apple.mpegurl')) {
      video.src = hlsUrl;
      // Don't auto-play here - wait for initAndPlay
    } else if (window.Hls && Hls.isSupported()) {
      const hls = new Hls({
        autoStartLoad: true,
        maxBufferLength: 3,
        maxMaxBufferLength: 5,
      });
      hls.loadSource(hlsUrl);
      hls.attachMedia(video);
      // Don't auto-play here - wait for initAndPlay
    }
    });
  } else if (mp4Url) {
    video.src = mp4Url;
    // Don't auto-play here - wait for initAndPlay
  }
}
let gallerySliderObserver = null;
let originalMainSlides = null;
let originalThumbSlides = null;
let slidesInitialized = false;
let globalAutoplayTimeout = null;
let globalSliderInView = true;
let globalImageCheckTimeout = null;
let galleryReady = false;
let currentVariantFilter = 'all';
let pendingVariantFilter = null;
// Store all variant slides data in JSON instead of DOM
let variantSlidesData = {
  main: {},
  thumb: {}
};

function markGalleryReady() {
  if (galleryReady) return;
  galleryReady = true;
  if (pendingVariantFilter && pendingVariantFilter !== currentVariantFilter) {
    const variantToApply = pendingVariantFilter;
    pendingVariantFilter = null;
    filterAndReinitSlickSliders(variantToApply);
  } else {
    pendingVariantFilter = null;
  }
}
// Extract slide data into JSON structure
function extractSlideData($slide) {
  const variant = ($slide.data('variant') || 'all').toString().toLowerCase().replace(/\s+/g, '');
  const deviceAttr = $slide.data('devices') || $slide.data('device') || 'all';
  const device = deviceAttr.toString().toLowerCase().replace(/\s+/g, '');
  
  const slideData = {
    variant: variant,
    device: device,
    html: $slide[0].outerHTML,
    hasVideo: $slide.find('video').length > 0,
    hasImage: $slide.find('img').length > 0
  };
  
  // Extract image/video sources for lazy loading
  const $img = $slide.find('img').first();
  const $video = $slide.find('video').first();
  
  if ($img.length) {
    slideData.imageSrc = $img.attr('src') || $img.attr('data-src');
    slideData.imageSrcset = $img.attr('srcset');
    slideData.imageAlt = $img.attr('alt');
    slideData.imageLazy = $img.attr('loading') === 'lazy';
  }
  
  if ($video.length) {
    slideData.videoHls = $video.attr('data-hls');
    slideData.videoSrc = $video.attr('data-src');
    slideData.videoPoster = $video.attr('poster');
  }
  
  return slideData;
}

// Store all slides data in JSON organized by variant
function storeOriginalSlides() {
  const $mainSlider = $('.product-main-slider');
  const $thumbSlider = $('.product-thumb-slider');
  
  if (!$mainSlider.length || !$thumbSlider.length) {
    return false;
  }
  
  const currentMainSlides = $mainSlider.find('.slide');
  const currentThumbSlides = $thumbSlider.find('.slide');
  
  // Only extract if not already done or if we have more slides
  if (!slidesInitialized || currentMainSlides.length > Object.keys(variantSlidesData.main).length) {
    variantSlidesData.main = {};
    variantSlidesData.thumb = {};
    originalMainSlides = [];
    originalThumbSlides = [];
    
    // Extract main slides data (preserve original DOM order via originalIndex)
    currentMainSlides.each(function(index) {
      const $slide = $(this);
      const slideData = extractSlideData($slide);
      slideData.originalIndex = index;
      const key = `slide_${index}`;
      
      // Group by variant for easy lookup
      if (!variantSlidesData.main[slideData.variant]) {
        variantSlidesData.main[slideData.variant] = [];
      }
      variantSlidesData.main[slideData.variant].push(slideData);
      
      // Also store in flat array for backward compatibility
      originalMainSlides.push($slide.clone(true)[0]);
    });
    
    // Extract thumb slides data (preserve original DOM order via originalIndex)
    currentThumbSlides.each(function(index) {
      const $slide = $(this);
      const slideData = extractSlideData($slide);
      slideData.originalIndex = index;
      const key = `slide_${index}`;
      
      // Group by variant for easy lookup
      if (!variantSlidesData.thumb[slideData.variant]) {
        variantSlidesData.thumb[slideData.variant] = [];
      }
      variantSlidesData.thumb[slideData.variant].push(slideData);
      
      // Also store in flat array for backward compatibility
      originalThumbSlides.push($slide.clone(true)[0]);
    });
    
    slidesInitialized = true;
    return true;
  }
  
  return slidesInitialized;
}

// Create slide element from JSON data (only when needed)
function createSlideFromData(slideData, isLazy = false) {
  const $temp = $('<div>').html(slideData.html);
  const $slide = $temp.find('.slide').first();
  
  if (!$slide.length) {
    // If structure is different, create from scratch
    const slide = $('<div>').addClass('slide')
      .attr('data-variant', slideData.variant)
      .attr('data-devices', slideData.device);
    
    if (slideData.hasImage && slideData.imageSrc) {
      const $img = $('<img>')
        .attr('alt', slideData.imageAlt || '')
        .addClass('lazy-image');
      
      if (isLazy) {
        $img.attr('data-src', slideData.imageSrc)
            .attr('loading', 'lazy');
        if (slideData.imageSrcset) {
          $img.attr('data-srcset', slideData.imageSrcset);
        }
      } else {
        $img.attr('src', slideData.imageSrc);
        if (slideData.imageSrcset) {
          $img.attr('srcset', slideData.imageSrcset);
        }
      }
      slide.append($img);
    }
    
    if (slideData.hasVideo) {
      const $video = $('<video>')
        .addClass('hls-video')
        .attr('playsinline', '')
        .attr('muted', '')
        .attr('preload', 'metadata');
      
      if (slideData.videoHls) {
        $video.attr('data-hls', slideData.videoHls);
      }
      if (slideData.videoSrc) {
        $video.attr('data-src', slideData.videoSrc);
      }
      if (slideData.videoPoster) {
        $video.attr('poster', slideData.videoPoster);
      }
      
      slide.append($video);
      
      // Add video controls buttons
      slide.append($('<button>').addClass('prdgalleyMute mutedButton_slider muted'));
      slide.append($('<button>').addClass('fullscreenButton_slider'));
    }
    
    return slide[0];
  }
  
  // Reset video state for cloned slides
  $slide.find('video').each(function() {
    const video = this;
    video.removeAttribute('src');
    video.load();
  });
  
  // Reset button states
  $slide.find('.mutedButton_slider, .fullscreenButton_slider').each(function() {
    this.dataset.bound = null;
  });
  
  // Update lazy loading attributes if needed
  if (isLazy) {
    $slide.find('img').each(function() {
      const $img = $(this);
      // v39: NEVER demote the eager LCP pick — stashing its src re-lazified the one image the v32c
      // Liquid pick deliberately made parser-discoverable + fetchpriority=high.
      if ($img.attr('fetchpriority') === 'high') { return; }
      if ($img.attr('src') && !$img.attr('data-src')) {
        $img.attr('data-src', $img.attr('src'))
            .removeAttr('src')
            .attr('loading', 'lazy');
        if ($img.attr('srcset')) {
          $img.attr('data-srcset', $img.attr('srcset'))
              .removeAttr('srcset');
        }
      }
    });
  }
  
  return $slide[0];
}

function filterAndReinitSlickSliders(currentVariant) {
  
  const $mainSlider = $('.product-main-slider');
  const $thumbSlider = $('.product-thumb-slider');
  const $sliderWrapper = $(".product-slider-wrapper");

  if (!$mainSlider.length || !$thumbSlider.length) {
    return;
  }
  const isAlreadyInitialized = $mainSlider.hasClass('slick-initialized');
  $sliderWrapper.addClass("loading-logo");
  if (isAlreadyInitialized) {
    $mainSlider.css({"opacity": "0.5", "visibility": "visible"});
    $thumbSlider.css({"opacity": "0.5", "visibility": "visible"});
  } else {
    $mainSlider.css({"opacity": "0", "visibility": "visible"});
    $thumbSlider.css({"opacity": "0", "visibility": "visible"});
  }

  const isMobile = window.innerWidth <= 767;
  const deviceType = isMobile ? 'mobile' : 'desktop';
  const normalizedVariant = (currentVariant || 'all').toLowerCase().replace(/\s+/g, '');
  galleryReady = false;
  currentVariantFilter = normalizedVariant;
  pendingVariantFilter = null;
  
  // Clear all autoplay timeouts when variant changes
  if (globalAutoplayTimeout) {
    clearTimeout(globalAutoplayTimeout);
    globalAutoplayTimeout = null;
  }
  if (globalImageCheckTimeout) {
    clearTimeout(globalImageCheckTimeout);
    globalImageCheckTimeout = null;
  }
  
  // Also clear any autoplay timeout that might be in the autoplaySlidesOnTimer scope
  // We'll need to clear it again after sliders are reinitialized
  if (!$sliderWrapper.hasClass("loading-logo")) {
    $sliderWrapper.addClass("loading-logo");
  }
  const videoCount = $mainSlider.find('.slide video').length;
  $mainSlider.find('.slide video').each(function() {
    const video = this;
    if (video && !video.paused) {
      video.pause();
      video.currentTime = 0;
    }
  });
  $mainSlider.find('.mutedButton_slider, .fullscreenButton_slider').each(function() {
    this.dataset.bound = null;
  });
  if (gallerySliderObserver) {
    gallerySliderObserver.disconnect();
    gallerySliderObserver = null;
  }
  // Extract slides data into JSON if not already done
  if (!slidesInitialized || Object.keys(variantSlidesData.main).length === 0) {
    storeOriginalSlides();
  }
  
  // Get slides from JSON data instead of DOM
  const filteredMainSlides = [];
  const filteredThumbSlides = [];
  
  // Get all variant keys (including 'all')
  const allVariants = Object.keys(variantSlidesData.main);
  const isMetagallery = allVariants.length > 0 && !variantSlidesData.main['all'] && allVariants.every(v => v !== 'all');
  
  // Filter main slides from JSON data, then sort by original render order
  const matchingMainSlideData = [];
  allVariants.forEach(function(variant) {
    const slides = variantSlidesData.main[variant] || [];
    slides.forEach(function(slideData) {
      const matchVariant = (slideData.variant === 'all' || slideData.variant === normalizedVariant);
      const matchDevice = (slideData.device === 'all' || 
                          slideData.device === deviceType || 
                          slideData.device.includes(deviceType) ||
                          (deviceType === 'desktop' && !slideData.device.includes('mobile')) ||
                          (deviceType === 'mobile' && slideData.device.includes('mobile')));
      
      if (matchVariant && matchDevice) {
        matchingMainSlideData.push(slideData);
      }
    });
  });
  matchingMainSlideData.sort(function(a, b) {
    return (a.originalIndex != null ? a.originalIndex : 0) - (b.originalIndex != null ? b.originalIndex : 0);
  });
  matchingMainSlideData.forEach(function(slideData) {
    const slideElement = createSlideFromData(slideData, false);
    filteredMainSlides.push(slideElement);
  });
  
  // Filter thumb slides from JSON data, then sort by original render order
  const allThumbVariants = Object.keys(variantSlidesData.thumb);
  const matchingThumbSlideData = [];
  allThumbVariants.forEach(function(variant) {
    const slides = variantSlidesData.thumb[variant] || [];
    slides.forEach(function(slideData, index) {
      let shouldShow = false;
      
      if (isMetagallery) {
        // Match with corresponding main slide
        const mainVariant = slideData.variant;
        const matchVariant = (mainVariant === 'all' || mainVariant === normalizedVariant);
        const matchDevice = (slideData.device === 'all' || 
                            slideData.device === deviceType || 
                            slideData.device.includes(deviceType) ||
                            (deviceType === 'desktop' && !slideData.device.includes('mobile')) ||
                            (deviceType === 'mobile' && slideData.device.includes('mobile')));
        shouldShow = matchVariant && matchDevice;
      } else {
        const matchVariant = (slideData.variant === 'all' || slideData.variant === normalizedVariant);
        const matchDevice = (slideData.device === 'all' || 
                            slideData.device === deviceType || 
                            slideData.device.includes(deviceType) ||
                            (deviceType === 'desktop' && !slideData.device.includes('mobile')) ||
                            (deviceType === 'mobile' && slideData.device.includes('mobile')));
        shouldShow = matchVariant && matchDevice;
      }
      
      if (shouldShow) {
        matchingThumbSlideData.push(slideData);
      }
    });
  });
  matchingThumbSlideData.sort(function(a, b) {
    return (a.originalIndex != null ? a.originalIndex : 0) - (b.originalIndex != null ? b.originalIndex : 0);
  });
  matchingThumbSlideData.forEach(function(slideData) {
    const slideElement = createSlideFromData(slideData, false);
    filteredThumbSlides.push(slideElement);
  });
  
  const visibleMainCount = filteredMainSlides.length;
  const visibleThumbCount = filteredThumbSlides.length;
  setTimeout(function() {
    $sliderWrapper.addClass("loading-logo");
    if ($mainSlider.hasClass('slick-initialized')) {
      try {
        $mainSlider.slick('unslick');
      } catch(e) {
      }
    }
    if ($thumbSlider.hasClass('slick-initialized')) {
      try {
        $thumbSlider.slick('unslick');
      } catch(e) {
      }
    }
      setTimeout(function() {
        $mainSlider.empty().append(filteredMainSlides);
        $thumbSlider.empty().append(filteredThumbSlides);
        
        // Initialize lazy loading for images with data-src
        $mainSlider.find('img[data-src]').each(function() {
          const $img = $(this);
          const img = this;
          
          // Use Intersection Observer for lazy loading
          if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver(function(entries, observer) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  const img = entry.target;
                  if (img.dataset.src) {
                    // v39: srcset BEFORE src — assigning src first fired the stashed BASE url (width=1920)
                    // at Low priority, double-fetching the already-loaded eager rendition and painting the
                    // oversized late one (LCP 'discoverable=false' on 23/31 PDPs). With srcset applied first,
                    // selection picks the sized rendition (usually already in cache from the eager pick).
                    if (img.dataset.srcset) {
                      img.srcset = img.dataset.srcset;
                    }
                    img.src = img.dataset.src;
                    img.removeAttribute('data-src');
                    img.removeAttribute('data-srcset');
                    img.removeAttribute('loading');
                  }
                  observer.unobserve(img);
                }
              });
            }, { rootMargin: '50px' });
            
            imageObserver.observe(img);
          } else {
            // Fallback for browsers without IntersectionObserver (v39: srcset first, same as the IO path)
            if (img.dataset.src) {
              if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
              }
              img.src = img.dataset.src;
              img.removeAttribute('data-src');
              img.removeAttribute('data-srcset');
            }
          }
        });
        
        $mainSlider.css({"opacity": "1", "visibility": "visible", "left": "0px"});
        $thumbSlider.css({"opacity": "1", "visibility": "visible", "left": "0px"});
        setTimeout(function() {
          if ($sliderWrapper.hasClass("loading-logo")) {
            $sliderWrapper.removeClass("loading-logo");
          }
        }, 200);
        
        // Clear any existing autoplay timeout before initializing new slider
        // This is critical when variant changes and first slide is a video
        if (globalAutoplayTimeout) {
          clearTimeout(globalAutoplayTimeout);
          globalAutoplayTimeout = null;
        }
        
        // Check if first slide is a video - if so, we'll handle it in startAutoplay
        const firstSlide = filteredMainSlides[0];
        if (firstSlide) {
          const $firstSlide = $(firstSlide);
          const firstVideo = $firstSlide.find('video')[0];
          if (firstVideo) {
            // First slide is a video - ensure autoplay is cleared
            // This will be handled in startAutoplay, but clear it here too for safety
          }
        }
        
        autoplaySlidesOnTimer();
      }, 100);
  }, 800);
}
function autoplaySlidesOnTimer() {
  const $mainSlider = $('.product-main-slider');
  const $thumbSlider = $('.product-thumb-slider');
  const mainSlideCount = $mainSlider.find('.slide').length;
  const thumbCount = $thumbSlider.find('.slide').length;
  const actualMainCount = mainSlideCount;
  const actualThumbCount = thumbCount;
  
  let autoplayTimeout = null;
  let sliderInView = true;
  let isCurrentSlideVideo = false; // Flag to track if current slide is a video

  const isMobile = window.innerWidth <= 767;
  const defaultThumbnails = isMobile ? 5 : 7;
  if (actualThumbCount === 0 || actualMainCount === 0) {
    return;
  }
  initializeSliders(actualMainCount, actualThumbCount);
  
  function initializeSliders(mainCount, thumbCount) {

  const thumbSliderOptions = {
    slidesToShow: defaultThumbnails,
    vertical: !isMobile,
    verticalSwiping: !isMobile,
    arrows: false,
    asNavFor: '.product-main-slider',
    focusOnSelect: true,
    swipeToSlide: true,
    centerPadding:0,
    centerMode: isMobile,
    infinite: thumbCount > defaultThumbnails,
  };
  
  // Add click handler to thumbnails to clear autoplay immediately when clicked
  $thumbSlider.off('click', '.slide');
  $thumbSlider.on('click', '.slide', function() {
    // Clear autoplay timeout immediately when thumbnail is clicked
    clearAutoplay();
    if (autoplayTimeout) {
      clearTimeout(autoplayTimeout);
      autoplayTimeout = null;
    }
    
    // Check if the clicked thumbnail corresponds to a video slide
    const clickedIndex = $(this).index();
    const $mainSlides = $mainSlider.find('.slide');
    const $targetSlide = $mainSlides.eq(clickedIndex);
    const targetVideo = $targetSlide.find('video')[0];
    
    if (targetVideo) {
      // Target slide is a video - set flag and clear autoplay multiple times
      isCurrentSlideVideo = true;
      clearAutoplay();
      if (autoplayTimeout) {
        clearTimeout(autoplayTimeout);
        autoplayTimeout = null;
      }
      // Force clear
      autoplayTimeout = null;
      
      // Add delayed clear to catch any race conditions
      setTimeout(() => {
        clearAutoplay();
        if (autoplayTimeout) {
          clearTimeout(autoplayTimeout);
          autoplayTimeout = null;
        }
        isCurrentSlideVideo = true; // Ensure flag is still set
      }, 10);
    } else {
      // Target slide is an image - reset flag and ensure autoplay will restart
      isCurrentSlideVideo = false;
      
      // After slide change completes, ensure autoplay restarts for image
      // Use a small delay to ensure the slide change has happened
      setTimeout(() => {
        const activeSlide = $mainSlider.find('.slide.slick-active');
        const activeVideo = activeSlide.find('video')[0];
        
        // Only restart autoplay if we're on an image slide (not video)
        if (!activeVideo && sliderInView && !isCurrentSlideVideo) {
          // Re-initialize autoplay for the image slide
          initAndPlay(activeSlide);
        }
      }, 100);
    }
  });
  $('.product-thumb-slider').on('wheel', function (e) {
  e.preventDefault();

  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickPrev');
  } else {
    $(this).slick('slickNext');
  }
});

  const mainSliderOptions = {
    slidesToShow: 1,
    arrows: false,
    asNavFor: '.product-thumb-slider',
    fade: true,
    infinite: true,
    draggable: true,
    swipe: true,
    touchMove: true,
  };

  if (thumbCount <= defaultThumbnails) {
    $thumbSlider.addClass('no-transition');
  } else {
    $thumbSlider.removeClass('no-transition');
  }

  if (thumbCount === 7 && !isMobile) {
    $thumbSlider.addClass('no-shadow');
  } else {
    $thumbSlider.removeClass('no-shadow');
  }
    $mainSlider.off('init.slick reInit.slick');
    const initNamespace = 'init.' + Date.now();
    
    $mainSlider.on('init.slick ' + initNamespace, function (event, slick) {
      
      const $sliderWrapper = $(".product-slider-wrapper");
      const slides = slick.$slides;
      setTimeout(function() {
        $sliderWrapper.removeClass("loading-logo");
      }, 400);
      const images = [];
      if (globalImageCheckTimeout) {
        clearTimeout(globalImageCheckTimeout);
        globalImageCheckTimeout = null;
      }
      slides.each(function() {
        const $slide = $(this);
        const slideImages = $slide.find('img');
        slideImages.each(function() {
          if (!this.complete || this.naturalHeight === 0 || !this.src) {
            images.push(this);
          }
        });
      });
      
      if (images.length > 0) {
        let loadedCount = 0;
        let checkedCount = 0;
        const totalImages = images.length;
        const maxWaitTime = 5000;
        const startTime = Date.now();
        
        const checkAllImages = function() {
          checkedCount++;
          loadedCount = 0;
          
          images.forEach(function(img) {
            if (img.complete && img.naturalHeight > 0 && img.src) {
              loadedCount++;
            }
          });
          
          const elapsed = Date.now() - startTime;
          const allLoaded = loadedCount === totalImages;
          const timeoutReached = elapsed >= maxWaitTime;
          
          if (allLoaded || timeoutReached) {
            if (globalImageCheckTimeout) {
              clearTimeout(globalImageCheckTimeout);
              globalImageCheckTimeout = null;
            }
            startAutoplay();
          } else {
            globalImageCheckTimeout = setTimeout(checkAllImages, 100);
          }
        };
        images.forEach(function(img) {
          if (img.complete && img.naturalHeight > 0 && img.src) {
          } else {
            const onImageLoad = function() {
              checkAllImages();
            };
            img.addEventListener('load', onImageLoad);
            img.addEventListener('error', onImageLoad);
          }
        });
        checkAllImages();
      } else {
        setTimeout(function() {
          $sliderWrapper.removeClass("loading-logo");
        }, 400);
        startAutoplay();
      }
      
      function startAutoplay() {
        if (!slick || !slick.$slides || slick.$slides.length === 0) {
          return;
        }
        
        // Clear any existing autoplay timeout before starting
        clearAutoplay();
        if (autoplayTimeout) {
          clearTimeout(autoplayTimeout);
          autoplayTimeout = null;
        }
        // Reset video flag
        isCurrentSlideVideo = false;
        
        setTimeout(() => {
          const current = slick.$slides.eq(0);
          if (current && current.length > 0) {
            // Check if first slide is a video - if so, clear autoplay immediately
            const firstVideo = current.find('video')[0];
            if (firstVideo) {
              // Set flag immediately to prevent any timer from being set
              isCurrentSlideVideo = true;
              
              // Clear autoplay timeout for video slides multiple times
              clearAutoplay();
              if (autoplayTimeout) {
                clearTimeout(autoplayTimeout);
                autoplayTimeout = null;
              }
              // Force clear
              autoplayTimeout = null;
              
              // Add a small delay to ensure any pending timers are cleared
              setTimeout(() => {
                clearAutoplay();
                if (autoplayTimeout) {
                  clearTimeout(autoplayTimeout);
                  autoplayTimeout = null;
                }
                isCurrentSlideVideo = true; // Ensure flag is still set
              }, 50);
            } else {
              // First slide is an image - ensure flag is false
              isCurrentSlideVideo = false;
            }
            
            initAndPlay(current);
            markGalleryReady();
          }
        }, 350);
      }
      $mainSlider.off('click', '.mutedButton_slider');
      $mainSlider.off('click', '.fullscreenButton_slider');
      $mainSlider.on('click', '.mutedButton_slider', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const button = this;
        const slide = $(button).closest('.slick-slide, .slide');
        const video = slide.find('video')[0];
        if (video) {
          video.muted = !video.muted;
          button.classList.toggle('muted', video.muted);
        }
      });
      $mainSlider.on('click', '.fullscreenButton_slider', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const button = this;
        const slide = $(button).closest('.slick-slide, .slide');
        const video = slide.find('video')[0];
        if (video) {
          if (video.requestFullscreen) {
            video.requestFullscreen().catch(() => {});
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen().catch(() => {});
          } else if (video.mozRequestFullScreen) {
            video.mozRequestFullScreen();
          } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
          }
        }
      });
      slick.$slider.off('beforeChange.slick');
      
      slick.$slider.on('beforeChange.slick', function (_, __, current, next) {
      // CRITICAL: Clear autoplay timeout IMMEDIATELY when slide changes
      // This must happen FIRST, before anything else, to prevent timer from firing
      // Do this multiple times to ensure it's completely cleared
      clearAutoplay();
      if (autoplayTimeout) {
        clearTimeout(autoplayTimeout);
        autoplayTimeout = null;
      }
      // Force clear one more time to be absolutely certain
      autoplayTimeout = null;
      
      // Get the next slide FIRST to check if it's a video
      const nextSlide = slick.$slides.eq(next);
      const nextVideo = nextSlide.find('video')[0];
      
      // If next slide has video, set flag IMMEDIATELY before anything else
      // This prevents the timeout callback from executing
      if (nextVideo) {
        isCurrentSlideVideo = true;
      } else {
        isCurrentSlideVideo = false;
      }
      
      // Clear autoplay again after setting flag
      clearAutoplay();
      if (autoplayTimeout) {
        clearTimeout(autoplayTimeout);
        autoplayTimeout = null;
      }
      
      // Stop current media
      stopCurrentMedia(slick.$slides);
      
      // If next slide has video, ensure autoplay is cleared (videos should play fully)
      // This is critical when clicking thumbnail to go to video slide
      if (nextVideo) {
        // Clear autoplay multiple times to be absolutely sure
        // This prevents any remaining timer from the previous image slide
        clearAutoplay();
        if (autoplayTimeout) {
          clearTimeout(autoplayTimeout);
          autoplayTimeout = null;
        }
        // Force clear - videos should never have autoplay timer
        autoplayTimeout = null;
        
        // Also pause and reset the video to ensure clean state
        nextVideo.pause();
        nextVideo.currentTime = 0;
        
        // Add multiple delayed clears to catch any race conditions
        setTimeout(() => {
          isCurrentSlideVideo = true; // Ensure flag is set
          clearAutoplay();
          if (autoplayTimeout) {
            clearTimeout(autoplayTimeout);
            autoplayTimeout = null;
          }
        }, 5);
        
        setTimeout(() => {
          isCurrentSlideVideo = true; // Ensure flag is still set
          clearAutoplay();
          if (autoplayTimeout) {
            clearTimeout(autoplayTimeout);
            autoplayTimeout = null;
          }
        }, 20);
      }
      
      // Initialize and play the next slide
      // This will also clear autoplay if it's a video
      initAndPlay(nextSlide);

      const totalSlides = slick.slideCount;
      const currentSlide = slick.currentSlide;
      if (currentSlide === totalSlides - 1 && next === 0) {
        $thumbSlider.slick('slickGoTo', 0);
      } else if (currentSlide === 0 && next === totalSlides - 1) {
        $thumbSlider.slick('slickGoTo', totalSlides - 1);
      } else {
        $thumbSlider.slick('slickGoTo', next);
      }
    });
  });
  try {
    if (!$mainSlider.length || !$thumbSlider.length) {
      return;
    }
    const mainSlides = $mainSlider.find('.slide');
    const thumbSlides = $thumbSlider.find('.slide');
    
    if (mainSlides.length === 0) {
      return;
    }
    
    if (thumbSlides.length === 0) {
      return;
    }
    $mainSlider.removeClass('slick-initialized');
    $thumbSlider.removeClass('slick-initialized');
    $mainSlider.slick(mainSliderOptions);
    setTimeout(() => {
      $thumbSlider.slick(thumbSliderOptions);
      if (!$mainSlider.hasClass('slick-initialized')) {
      }
      if (!$thumbSlider.hasClass('slick-initialized')) {
      }
    }, 100);
    
  } catch (error) {
    const firstMain = $mainSlider.find('.slide').first();
    const firstThumb = $thumbSlider.find('.slide').first();
    if (firstMain.length) firstMain.show();
    if (firstThumb.length) firstThumb.show();
  }

  function initAndPlay(slide) {
    const video = slide.find('video')[0];
    const image = slide.find('img').first()[0];
    const slideIndex = slide.index();
    
    // CRITICAL: Always clear autoplay timeout FIRST, before any other logic
    // This prevents any timer from previous slide (especially image with 5-sec timer) from firing
    clearAutoplay();
    if (autoplayTimeout) {
      clearTimeout(autoplayTimeout);
      autoplayTimeout = null;
    }
    // Force clear to ensure no timer exists
    autoplayTimeout = null;
    
    // Set flag to track if current slide is a video
    isCurrentSlideVideo = !!video;
    
    if (!sliderInView) {
      return;
    }

    if (video) {
      // CRITICAL: For videos, clear autoplay timeout MULTIPLE times
      // This is essential when switching from image (with 5-sec timer) to video
      clearAutoplay();
      if (autoplayTimeout) {
        clearTimeout(autoplayTimeout);
        autoplayTimeout = null;
      }
      // Force clear - videos should NEVER have autoplay timer
      autoplayTimeout = null;
      
      // Add a small delay to ensure any pending timers are cleared
      // This is critical for first video click after variant change
      setTimeout(() => {
        clearAutoplay();
        if (autoplayTimeout) {
          clearTimeout(autoplayTimeout);
          autoplayTimeout = null;
        }
      }, 50);
      
      // Remove any existing onended handlers to prevent duplicates
      video.onended = null;
      
      // Reset video state completely
      video.pause();
      video.currentTime = 0;
      
      // Set up video to play fully before advancing
      const setupVideoPlayback = () => {
        // Clear any autoplay timeout multiple times to be absolutely sure
        // This is critical for first video after variant change
        clearAutoplay();
        if (autoplayTimeout) {
          clearTimeout(autoplayTimeout);
          autoplayTimeout = null;
        }
        // Force clear one more time
        autoplayTimeout = null;
        isCurrentSlideVideo = true; // Ensure flag is set
        
        // Set handler to advance only when video ends
        video.onended = () => {
          clearAutoplay();
          if (autoplayTimeout) {
            clearTimeout(autoplayTimeout);
            autoplayTimeout = null;
          }
          isCurrentSlideVideo = false; // Reset flag when video ends
          if (sliderInView) {
            $mainSlider.slick('slickNext');
          }
        };
        
        // Play the video
        video.play().catch(() => {});
      };
      
      // Handle video loading
      if (!video.src || video.readyState === 0) {
        video.pause();
        video.currentTime = 0;
        
        // Load video and wait for it to be ready
        loadVideo(video);
        
        // Wait for video to be loaded before playing
        const onVideoReady = () => {
          video.removeEventListener('loadeddata', onVideoReady);
          video.removeEventListener('canplay', onVideoReady);
          setupVideoPlayback();
        };
        
        video.addEventListener('loadeddata', onVideoReady, { once: true });
        video.addEventListener('canplay', onVideoReady, { once: true });
        
        // Fallback: if video takes too long, play anyway after 2 seconds
        setTimeout(() => {
          if (video.readyState === 0 || !video.src) {
            setupVideoPlayback();
          }
        }, 2000);
      } else {
        // Video already loaded, reset and play
        video.currentTime = 0;
        setupVideoPlayback();
      }
      
      // Handle manual video clicks/plays - ensure it plays fully
      const handleVideoInteraction = () => {
        clearAutoplay();
        // Ensure video plays fully - don't advance until it ends
        if (video.paused) {
          video.play().catch(() => {});
        }
      };
      
      // Listen for play events (both auto and manual)
      // This is critical when clicking thumbnail to go to video - clear any pending autoplay
      video.addEventListener('play', function onVideoPlay() {
        // Set flag immediately when video starts playing
        isCurrentSlideVideo = true;
        
        // Clear autoplay timeout multiple times to be absolutely sure
        clearAutoplay();
        if (autoplayTimeout) {
          clearTimeout(autoplayTimeout);
          autoplayTimeout = null;
        }
        // Force clear
        autoplayTimeout = null;
        
        // Add one more delayed clear to catch any race conditions
        setTimeout(() => {
          clearAutoplay();
          if (autoplayTimeout) {
            clearTimeout(autoplayTimeout);
            autoplayTimeout = null;
          }
          isCurrentSlideVideo = true; // Ensure flag is still set
        }, 20);
        
        // Ensure onended handler is set to advance only when video finishes
        if (!video.onended) {
          video.onended = () => {
            clearAutoplay();
            if (autoplayTimeout) {
              clearTimeout(autoplayTimeout);
              autoplayTimeout = null;
            }
            isCurrentSlideVideo = false; // Reset flag when video ends
            if (sliderInView) {
              $mainSlider.slick('slickNext');
            }
          };
        }
      }, { once: false }); // Don't use once - we want this to fire every time video plays
      
      // Also handle click events on video
      video.addEventListener('click', handleVideoInteraction, { once: false });
      
    } else {
      // For images, use 5 second autoplay
      // BUT only if we're not on a video slide (safety check)
      if (!isCurrentSlideVideo) {
        // Store the current slide index to verify we're still on the same slide
        const currentSlideIndex = slideIndex;
        const currentSlideElement = slide[0];
        
        autoplayTimeout = setTimeout(() => {
          // CRITICAL: Multiple safety checks before advancing
          // 1. Check flag
          // 2. Check if slider is still in view
          // 3. Verify we're still on the same slide (not switched to video)
          // 4. Verify the current active slide is still an image (not a video)
          const activeSlide = $mainSlider.find('.slide.slick-active');
          const activeVideo = activeSlide.find('video')[0];
          
          if (!isCurrentSlideVideo && 
              sliderInView && 
              !activeVideo &&
              activeSlide.length > 0 &&
              activeSlide[0] === currentSlideElement) {
            $mainSlider.slick('slickNext');
          }
        }, 5000);
      }
    }
  }

  function stopCurrentMedia(slides) {
    let stoppedCount = 0;
    slides.each((_, slide) => {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
        video.currentTime = 0;
        video.onended = null;
        stoppedCount++;
      }
    });
    if (stoppedCount > 0) {
    }
  }

  function clearAutoplay() {
    if (autoplayTimeout) {
      clearTimeout(autoplayTimeout);
      autoplayTimeout = null;
    }
  }
  if (gallerySliderObserver) {
    gallerySliderObserver.disconnect();
  }

  gallerySliderObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const isIntersecting = entry.isIntersecting;
        
        if (!isIntersecting) {
          sliderInView = false;
          clearAutoplay();
          stopCurrentMedia($mainSlider.find('.slide'));
        } else {
          sliderInView = true;
          const current = $mainSlider.find('.slide.slick-active');
          if (current.length > 0) {
            initAndPlay(current);
          } else {
          }
        }
      });
    },
    { threshold: 0 }
  );

  const sliderElement = document.querySelector('.product-main-slider');
  if (sliderElement) {
    gallerySliderObserver.observe(sliderElement);
  }
  
  }
}

function initProductGallery() {
  storeOriginalSlides();
  initProductGalleryVideos();
  const selectedInput = document.querySelector('input.variant__input--color-swatch[name="Color"]:checked');
  if (selectedInput) {
    const fallbackName = selectedInput.value;
    const newVariant = fallbackName.toLowerCase().replace(/\s+/g, '');
    filterAndReinitSlickSliders(newVariant);
  } else {
    // For products without color variants, still run through the unified
    // filter logic so that device-specific filtering (mobile / desktop)
    // is applied both on initial load and after breakpoint changes.
    filterAndReinitSlickSliders('all');
  }
}


let currentIsMobile = window.innerWidth <= 767;

function reinitOnResize() {
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      const newIsMobile = window.innerWidth <= 767;
      if (newIsMobile !== currentIsMobile) {
        currentIsMobile = newIsMobile;
        if ($('.product-main-slider').hasClass('slick-initialized')) {
          $('.product-main-slider').slick('unslick');
        }
        if ($('.product-thumb-slider').hasClass('slick-initialized')) {
          $('.product-thumb-slider').slick('unslick');
        }
        const videos = document.querySelectorAll('.video');
        videos.forEach(video => {
          try {
            video.pause();
            video.removeAttribute('src');
            video.load();
          } catch (e) {}
        });
        initProductGallery();
      }
    }, 300);
  });
}
function waitForAllImages(selector, callback) {
  const container = document.querySelector(selector);
  if (!container) return callback();

  const images = container.querySelectorAll('img');
  const total = images.length;
  if (!total) return callback();

  // Fire the callback EXACTLY ONCE (guards the failsafe + natural-completion race so initProductGallery isn't double-run).
  let done = false;
  let failsafe;
  const finish = () => { if (done) return; done = true; if (failsafe) clearTimeout(failsafe); callback(); };

  let loadedCount = 0;
  const imageLoaded = () => { loadedCount++; if (loadedCount >= total) finish(); };

  // Failsafe: never let a hung or src-less image block gallery init (the old jQuery imagesLoaded always resolved).
  failsafe = setTimeout(finish, 3000);

  images.forEach((img) => {
    // js_lazy gallery slides carry data-src with an EMPTY src (Stage-5 lazy-load) — don't block on them; the gallery's
    // own IntersectionObserver loads them on view. (tempImg.src='' would never fire load/error and would stall forever.)
    if (!img.getAttribute('src')) { imageLoaded(); return; }
    if (img.complete && img.naturalHeight !== 0) {
      imageLoaded();
    } else {
      const tempImg = new Image();
      tempImg.onload = imageLoaded;
      tempImg.onerror = imageLoaded;
      tempImg.src = img.src;
    }
  });
}


document.addEventListener('DOMContentLoaded', () => {
  // Native replacement for $('.product-main-slider').imagesLoaded(...) — drops the jQuery imagesLoaded plugin
  // (imagesloaded.pkgd.min.js), the last live consumer, so that 5.4KB/263–329ms-PDP lib can be removed from theme.liquid.
  waitForAllImages('.product-main-slider', function() {
    initProductGallery();
  });
  reinitOnResize();
});

document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.product-main-slider')) {
    initProductGallery();
  }
});




const COLOR_INPUT_SELECTOR = 'input.variant__input--color-swatch[name="Color"]';

function normalizeVariantName(value) {
  return (value || 'all').toString().toLowerCase().replace(/\s+/g, '');
}

function queueVariantFilter(variantName) {
  const normalized = normalizeVariantName(variantName);
  if (galleryReady) {
    if (normalized !== currentVariantFilter) {
      filterAndReinitSlickSliders(normalized);
    }
  } else {
    pendingVariantFilter = normalized;
  }
}

function updateColorSwatchBackground(target) {
  if (!target) return;
    if( target == 'all'){
      queueVariantFilter(target);
      const colorHex1 = document.querySelector(".atc_btn_selector")?.dataset.productColor;
      const colorPlate1 = document.querySelector('.single_pdp_summary')?.querySelector('.color_plate');
      const stickyColorPlate1 = document.querySelector('#sticky-atc .color_plate');
      if (colorPlate1 && colorHex1 ) {
        colorPlate1.classList.add('active');
        colorPlate1.style.backgroundColor = colorHex1;
      }
      if (stickyColorPlate1 && colorHex1 ) {
        stickyColorPlate1.classList.add('active');
        stickyColorPlate1.style.backgroundColor = colorHex1;
      }
      return;
    }
  const colorValueAttr = target.getAttribute('data-color-hex');
  const dataShape = target.getAttribute('data-shape');
  const fallbackName = target.value;
  const base = colorValueAttr && colorValueAttr.trim() !== '' ? colorValueAttr : fallbackName;
  const colorHex = base.startsWith('#') ? base : `#${base}`;
  const colorPlate = target.closest('.single_pdp_summary')?.querySelector('.color_plate');
  const stickyColorPlate = document.querySelector('#sticky-atc .color_plate');
  const label = target.nextElementSibling;


  // Hide all sections
  document.querySelectorAll('.nail_shapes_section').forEach(section => {
    section.style.display = 'none';
  });
  document.querySelectorAll('.nail_shapes_section_mobile').forEach(section => {
    section.style.display = 'none';
  });

  // Show matching section
  const activeSection = document.querySelector(
    `.nail_shapes_section.${dataShape}_shape`
  );
  const activeSection_mobile = document.querySelector(
    `.nail_shapes_section_mobile.${dataShape}_shape_mobile`
  );

  if (activeSection) {
    activeSection.style.display = '';
    initCollectionProductSlider();
  }
  if (activeSection_mobile) {
    activeSection_mobile.style.display = '';
    // Rebuild Flickity now the variant is visible: an instance built while display:none
    // measured 0-width cells (initPDPMObileMediaSlider destroys any existing instance first).
    if (typeof initPDPMObileMediaSlider === 'function') initPDPMObileMediaSlider(activeSection_mobile);
  }

  dataShape

  if (label) {
    const url = label.dataset.previewImage;
   // const url = bg.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
    if (url && url.length > 6) {
      const body = document.body;
      $('.swatch-image-inline img.dynamic-swatch-inline').remove();
      const $swatchInlineImgs = $('.swatch-image-inline img');
      const appendClasses = [
        'product-luxe-contour-trio',
        'product-bronzing-powder-duo-set',
        'product-caroline-s-favorite'
      ];
      const shouldAppend = appendClasses.some(cls => body.classList.contains(cls));
      // Handle each swatch-inline container separately (main and sticky, etc.)
      $('.swatch-image-inline').each(function() {
        const $container = $(this);

        if (shouldAppend) {
          // Remove any previously appended dynamic images in this container
          $container.find('img.dynamic-swatch-inline').remove();
        }
        let $imgs = $container.find('img');
        if (!$imgs.length) return;

        if (shouldAppend) {
          $container.addClass('swatch_dual');

          const $originalImg = $imgs.first();
          const newImg = $('<img>')
            .addClass(($originalImg.attr('class') || '') + ' dynamic-swatch-inline')
            .attr('src', url)
            .attr('srcset',
              `${url}&width=200 200w, ` +
              `${url}&width=400 400w, ` +
              `${url}&width=600 600w, ` +
              `${url}&width=800 800w`
            )
            .attr('sizes', '100vw')
            .attr('loading', 'eager')
            .attr('alt', fallbackName);

          newImg.insertBefore($originalImg);
        } else {
          // Fallback: update the existing image(s) in this container
          $imgs
            .attr('src', url)
            .attr('srcset',
              `${url}&width=200 200w, ` +
              `${url}&width=400 400w, ` +
              `${url}&width=600 600w, ` +
              `${url}&width=800 800w`
            )
            .attr('sizes', '100vw')
            .attr('loading', 'eager')
            .attr('alt', fallbackName);
        }
      });

    }
  }
  const variantInputContainer = target.closest('.variant-input');
  if (variantInputContainer) {
    setTimeout(() => {
      // v39: center the selected swatch INSIDE its horizontal strip only — scoped scrollLeft, never the window.
      // The old scrollIntoView also scrolled the WINDOW vertically whenever the strip sat slightly off-viewport
      // (a ~19px drift at load on 14/31 PDPs, since this runs for the PROGRAMMATIC initial variant select too);
      // that synthetic window-scroll tripped the first-interaction gates, loading the whole Gorgias suite in
      // every no-interaction session. Element scroll events don't bubble to window, so this can't re-trip them.
      let strip = variantInputContainer.parentElement;
      while (strip && strip !== document.body && strip.scrollWidth <= strip.clientWidth + 1) strip = strip.parentElement;
      if (!strip || strip === document.body || strip === document.documentElement) return;
      const stripRect = strip.getBoundingClientRect();
      const inputRect = variantInputContainer.getBoundingClientRect();
      const delta = (inputRect.left + inputRect.width / 2) - (stripRect.left + stripRect.width / 2);
      if (typeof strip.scrollTo === 'function') strip.scrollTo({ left: strip.scrollLeft + delta, behavior: 'smooth' });
      else strip.scrollLeft += delta;
    }, 100);
  }
  if (fallbackName) {
    $('h1.h2.product-single__title').text(fallbackName);
    $('.sticky-atc__title').text(fallbackName);
  }
  if (colorPlate) {
    colorPlate.classList.add('active');
    colorPlate.style.backgroundColor = colorHex;
  }
  if (stickyColorPlate) {
    stickyColorPlate.classList.add('active');
    stickyColorPlate.style.backgroundColor = colorHex;
  }
  if( fallbackName ){
    document.querySelectorAll('.variation_key_features').forEach(el => {
      const dataVar = el.dataset.variation;
      if (normalizeVariantName(dataVar) === normalizeVariantName(fallbackName)) {
        el.classList.remove('hide');
      } 
      else {
        el.classList.add('hide');
      }
    });
  }
  if( fallbackName ){
    document.querySelectorAll('.ingredients-by-variant').forEach(el => {
      const dataVar = el.dataset.variation;
      if (normalizeVariantName(dataVar) === normalizeVariantName(fallbackName)) {
        el.classList.remove('hide');
        const collapsible = el.closest('.collapsible-content');
        if (collapsible && collapsible.classList.contains('is-open')) {
          setTimeout(() => {
            collapsible.style.height = 'auto';
            const height = collapsible.scrollHeight;
            collapsible.style.height = height + 'px';
          }, 100);
        }
      } 
      else {
        el.classList.add('hide');
      }
    });
  }
  if( fallbackName ){
    document.querySelectorAll('.howtouse-by-variant').forEach(el => {
      const dataVar = el.dataset.variation;
      if (normalizeVariantName(dataVar) === normalizeVariantName(fallbackName)) {
        el.classList.remove('hide');
        const collapsible = el.closest('.collapsible-content');
        if (collapsible && collapsible.classList.contains('is-open')) {
          setTimeout(() => {
            collapsible.style.height = 'auto';
            const height = collapsible.scrollHeight;
            collapsible.style.height = height + 'px';
          }, 100);
        }
      } 
      else {
        el.classList.add('hide');
      }
    });
  }
  

  queueVariantFilter(fallbackName);
}

document.addEventListener('DOMContentLoaded', () => {
  const selectedInput = document.querySelector(`${COLOR_INPUT_SELECTOR}:checked`);
  if (selectedInput) {
    updateColorSwatchBackground(selectedInput);
  }
  else if (document.body.classList.contains('template-product')) {
    updateColorSwatchBackground('all');
  }
  
  document.addEventListener('change', event => {
    if (event.target.matches(COLOR_INPUT_SELECTOR) && event.target.checked) {
      updateColorSwatchBackground(event.target);
    }
  });
  
});
function initProductDescriptionToggle() {
  document.querySelectorAll('.product_description_rte').forEach(block => {
    const desc = block.querySelector('.js-desc');
    const btn = block.querySelector('.desc-toggle');

    if (!desc || !btn) return;

    const checkOverflow = () => {
      // reset first to measure correctly
      desc.classList.remove('is-expanded');
      btn.textContent = 'Read more';

      const isOverflowing = desc.scrollHeight > desc.clientHeight + 2;

      if (isOverflowing) {
        btn.hidden = false;
      } else {
        btn.hidden = true;
      }
    };

    // Initial check (after layout)
    requestAnimationFrame(checkOverflow);

    // Toggle
    if (!btn.dataset.bound) {
      btn.dataset.bound = 'true';
      btn.addEventListener('click', () => {
        const expanded = desc.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Read less' : 'Read more';
      });
    }

    // Re-check on resize (debounced)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkOverflow, 150);
    });
  });
}

// Init
document.addEventListener('DOMContentLoaded', initProductDescriptionToggle);

// Multiple Key Features Accordion
(function() {
  // Reuse the same accordion helper functions from product-accordion-block
  function getContentHeight(content) {
    if (!content) return 0;
    
    var originalHeight = content.style.height;
    var originalDisplay = content.style.display;
    
    // Temporarily show content to measure
    content.style.height = 'auto';
    content.style.display = 'block';
    content.style.visibility = 'hidden';
    
    var height = content.offsetHeight;
    
    // Restore original styles
    content.style.height = originalHeight;
    content.style.display = originalDisplay;
    content.style.visibility = '';
    
    return height;
  }
  
  function prepareTransition(element, callback) {
    element.classList.add('is-transitioning');
    if (callback) callback();
  }
  
  function setAccordionHeight(content, isOpening) {
    if (!content || !content.classList.contains('accordion-content')) return;
    
    if (isOpening) {
      content.classList.add('is-open');
      var height = getContentHeight(content);
      content.style.height = '0px';
      content.offsetWidth; // Force reflow
      prepareTransition(content, function() {
        content.style.height = height + 'px';
      });
      setTimeout(function() {
        if (content.classList.contains('is-open')) {
          content.style.height = 'auto';
        }
      }, 300);
    } else {
      var currentHeight = getContentHeight(content);
      content.style.height = currentHeight + 'px';
      content.offsetWidth; // Force reflow
      prepareTransition(content, function() {
        content.style.height = '0px';
        content.classList.remove('is-open');
      });
    }
  }
  
  function initMultipleKeyFeaturesAccordion() {
    // Find all multiple-key-features blocks
    var accordionGroups = document.querySelectorAll('.multiple-key-features-block[data-accordion-group]');
    
    accordionGroups.forEach(function(accordionGroup) {
      var trigger = accordionGroup.querySelector('[data-accordion-trigger]');
      
      if (trigger && !trigger.hasAttribute('data-accordion-initialized')) {
        trigger.setAttribute('data-accordion-initialized', 'true');
        
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          var clickedTrigger = e.currentTarget;
          var isOpening = !clickedTrigger.classList.contains('is-open');
          var content = clickedTrigger.nextElementSibling;
          
          // Toggle clicked accordion
          clickedTrigger.classList.toggle('is-open');
          clickedTrigger.setAttribute('aria-expanded', clickedTrigger.classList.contains('is-open'));
          setAccordionHeight(content, isOpening);
        });
      }
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMultipleKeyFeaturesAccordion);
  } else {
    initMultipleKeyFeaturesAccordion();
  }
  
  // Re-initialize on Shopify section load
  document.addEventListener('shopify:section:load', initMultipleKeyFeaturesAccordion);
  document.addEventListener('shopify:section:select', initMultipleKeyFeaturesAccordion);
})();





